import React, { useState, useEffect, useRef, useCallback } from 'react';
import { mount, unmount } from 'redom';

import isUrl from 'is-url';

import fileTypes from 'constants/file-types';

import HelptapColorPicker from 'generics/components/color-picker';
import MiniFileInput from 'generics/components/mini-file-input/react';

import PositionControl from './position-control/react';
import SizeControl from './size-control';

import { applyCSSVariables, repalceCSSVariables } from './utilities';

import './index.scss';

function BackgroundInput(props) {

  const [rootState, setRootState] = useState({
    backgroundColor: props.backgroundColor,
    backgroundImage: props.backgroundImage
  });

  const sizeControlContainerReference = useRef(null);
  const sizeControlReference = useRef(null);

  useEffect(function onBackgroundChange() {

    props.onChange(rootState);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootState]);

  const handleSizeChange = useCallback(function handleSizeChange(backgroundSize) {
    updateBackground('backgroundSize', backgroundSize);
  }, []);

  useEffect(function onSizeControlMount() {

    const container = sizeControlContainerReference.current;
    const sizeControl = new SizeControl({
      size: props.backgroundSize,
      onChange: handleSizeChange
    });
    sizeControlReference.current = sizeControl;

    mount(container, sizeControlReference.current);

    return function onSizeControlUnmount() {
      unmount(container, sizeControlReference.current);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function updateBackground(fieldName, value) {

    setRootState(function updateRootState(rootState) {

      return {
        ...rootState,
        [fieldName]: value
      };

    });

  }

  function handleBackgroundFile(file) {

    const fileUrl = file.url;

    updateBackground('backgroundImage', `url('${fileUrl}')`);

  }

  function handleBackgroundImageChange(event) {

    let backgroundImage = event.target.value;

    if (isUrl(backgroundImage) === true) {
      backgroundImage = `url('${backgroundImage}')`;
    } else {
      backgroundImage = applyCSSVariables(backgroundImage);
    }

    updateBackground('backgroundImage', backgroundImage);

  }

  function getBackgroundDisplayValue(value) {

    if (typeof value !== 'string') {
      return '';
    }

    if (value.indexOf('url(') === 0) {
      return value.substring(5, value.length - 2);
    }

    return repalceCSSVariables(value);

  }

  function renderBackgroundColorInputContent() {

    const colorPickerProperties = {
      color: rootState.backgroundColor,
      onChange(backgroundColor) {
        updateBackground('backgroundColor', backgroundColor);
      }
    };

    return <div className="node-properties-menu-color-picker-wrapper">
      <HelptapColorPicker {...colorPickerProperties} />
    </div>;
  }

  function renderBackgroundImageInputContent() {

    const inputAttributes = {
      id: 'background-image-input',
      type: 'text',
      placeholder: 'Gradient or url or both',
      value: getBackgroundDisplayValue(rootState.backgroundImage),
      onInput: handleBackgroundImageChange
    };

    const fileInputProperties = {
      application: props.application,
      uploader: props.mediaUploader,
      acceptedTypes: [fileTypes.IMAGE],
      onFile: handleBackgroundFile
    };

    return <div className="node-properties-menu-color-picker-wrapper background-inputs-container">
      <input {...inputAttributes} />
      <MiniFileInput {...fileInputProperties} />
    </div>;
  }

  function renderPositionControl() {

    const positionProperties = {
      position: props.backgroundPosition,
      onChange(backgroundPosition) {
        updateBackground('backgroundPosition', backgroundPosition);
      }
    };

    return <div className="node-properties-menu-color-picker-wrapper">
      <PositionControl {...positionProperties} />
    </div>;

  }

  function renderSizeControl() {

    return <div className="node-properties-menu-color-picker-wrapper" ref={sizeControlContainerReference}>
    </div>;

  }

  function renderMain() {

    return <div id="editor-background-input-main">
      {renderBackgroundColorInputContent()}
      {renderBackgroundImageInputContent()}
      {renderPositionControl()}
      {renderSizeControl()}
    </div>;

  }

  return renderMain();

}

export default BackgroundInput;